import moment from 'moment-timezone';
import { IFreeStorySchedule } from '../../services/types';
import useStyles from './style';
import { IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography, Link } from '@material-ui/core';
import React from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import settings from '../../services/settings';

interface IProps {
  schedules: IFreeStorySchedule[];
  onClickDeleteButton: (readingChallenge: IFreeStorySchedule) => void;
}

const FreeStoryList = (props: IProps): JSX.Element => {
  const classes = useStyles();
  const { schedules } = props;
  const now = moment();

  return (
    <Paper>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell align="center" className={classes.tdId}>
              ID
            </TableCell>
            <TableCell align="center" className={classes.tdId}>
              Story ID
            </TableCell>
            <TableCell align="center" className={classes.tdId}>
              Story Title
            </TableCell>
            <TableCell align="center" className={classes.tdId}>
              Status
            </TableCell>
            <TableCell align="center" className={classes.tdDate}>
              Start At
            </TableCell>
            <TableCell align="center" className={classes.tdDate}>
              End At
            </TableCell>
            <TableCell align="center" className={classes.tdDelete}>
              Delete
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {schedules &&
            schedules.map(sc => (
              <TableRow key={sc.id} hover className={now.isAfter(sc.endAt) ? classes.scEnd : now.isAfter(sc.startAt) ? classes.scIn : ''}>
                <TableCell align="center">{sc.id}</TableCell>
                <TableCell align="center">{sc.storyId}</TableCell>
                <TableCell align="left" className={classes.tdTitle}>
                  <Link href={`${settings.getCrewURI()}/stories/${sc.storyId}`} target="_blank">
                    {sc.story!.title}
                  </Link>
                </TableCell>
                <TableCell align="center">{now.isAfter(sc.endAt) ? 'Expired' : now.isAfter(sc.startAt) ? 'Live' : 'Scheduled'}</TableCell>
                <TableCell align="center">
                  {sc.startAt && moment(sc.startAt).format('llll')}
                  <br />
                  <Typography className={classes.utcTime}>
                    {sc.startAt &&
                      moment(sc.startAt)
                        .utc()
                        .format('llll')}{' '}
                    UTC
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  {sc.endAt && moment(sc.endAt).format('llll')}
                  <br />
                  <Typography className={classes.utcTime}>
                    {sc.startAt &&
                      moment(sc.endAt)
                        .utc()
                        .format('llll')}{' '}
                    UTC
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Tooltip title={''} placement="left-end">
                    <IconButton
                      color="primary"
                      onClick={e => {
                        e.stopPropagation();
                        props.onClickDeleteButton(sc);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default FreeStoryList;
